import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './home/index';
import {AuthenticationComponent, ForgotPwdComponent, ForgotPwdLinkComponent, LoginComponent, LogoutComponent, ResetPwdComponent, SecurityQuestionsComponent} from './login/index';
import {AuthGuard} from './_guards/index';
import {SamlLoginComponent} from './saml-login';
import {AccountConfirmationComponent} from './login/account-confirmation/account-confirmation';
import {TwoFASetupComponent} from './twoFA/twoFA-setup/twoFA-setup.component';
import {TwoFALoginAuthenticationComponent} from './twoFA/twoFA-login-authentication/twoFA-login-authentication.component';
import {ForgotUsernameComponent} from './login/forgot-username/forgot-username.component';
import {TwoFaConfirmationComponent} from './twoFA/two-fa-confirmation/two-fa-confirmation.component';
import {LinkAccountInfoComponent} from './link-accounts/link-account-info.component';
import {InvitationSignUpComponent} from './invitation-sign-up/invitation-sign-up.component';
import {FacebookCallbackComponent} from './invitation-sign-up/facebook-callback/facebook-callback.component';
import {GoogleCallbackComponent} from './invitation-sign-up/google-callback/google-callback.component';
import {LinkedinCallbackComponent} from './invitation-sign-up/linkedin-callback/linkedin-callback.component';
import {TwitterCallbackComponent} from './invitation-sign-up/twitter-callback/twitter-callback.component';
import {FacebookLoginCallbackComponent} from './invitation-sign-up/facebook-callback/facebook-login-callback/facebook-login-callback.component';
import {GoogleLoginCallbackComponent} from './invitation-sign-up/google-callback/google-login-callback/google-login-callback.component';
import {LinkedInLoginCallbackComponent} from './invitation-sign-up/linkedin-callback/linked-in-login-callback/linked-in-login-callback.component';
import {TwitterLoginCallbackComponent} from './invitation-sign-up/twitter-callback/twitter-login-callback/twitter-login-callback.component';
import {AuthenticationFacebookCallbackComponent} from './authentication-email/authentication-facebook-callback/authentication-facebook-callback.component';
import {AuthenticationGoogleCallbackComponent} from './authentication-email/authentication-google-callback/authentication-google-callback.component';
import {AuthenticationLinkedinCallbackComponent} from './authentication-email/authentication-linkedin-callback/authentication-linkedin-callback.component';
import {SpecificPlaceLoginComponent} from './specific-place-login/specific-place-login.component';
import {AppAuthenticationComponent} from './twoFA/app-authentication/app-authentication.component';
import { UserPromptSubmitComponent } from './user-prompt/user-prompt-submit.component';
import { EmailConfirmationComponent } from './login/email-confirmation/email-confirmation';
import {Oauth2LoginComponent} from './oauth2-login/oauth2-login.component';
import { OAuth2LogoutComponent } from './oauth2-login/oauth2-logout/oauth2-logout.component';
import { BrokerAuthorizeComponent } from './broker-authorize/broker-authorize.component';
import { BrokerLoginComponent } from './login/broker-login/broker-login.component';

const appRoutes: Routes = [
  { path: '', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'authentication-page', component: AuthenticationComponent },
  { path: 'reset-password', component: ResetPwdComponent },
  { path: 'forgot-password', component: ForgotPwdComponent },
  { path: 'forgot-username', component: ForgotUsernameComponent },
  { path: 'security-questions', component: SecurityQuestionsComponent },
  { path: 'password-recovery/token/:token/tenant/:tenant', component: ForgotPwdLinkComponent },
  { path: 'contact-method-confirm/email/token/:token/tenant/:tenant', component: EmailConfirmationComponent },
  { path: 'confirm-device-change/secret/:secret/tenant/:tenant/answer/:answer', component: TwoFaConfirmationComponent },
  { path: 'account-confirm/token/:token/userId/:userId/tenant/:tenant', component: AccountConfirmationComponent },
  { path: 'saml/sso', component: SamlLoginComponent },
  { path: 'oauth2/login', component: Oauth2LoginComponent },
  {
    path: "broker/login",
    component: BrokerLoginComponent,
    data: {
      backgroudImage: '../../../assets/img/broker-login-background.png',
    }
   },
  { path: 'oauth2/login', component: Oauth2LoginComponent },
  { path: 'oauth2/logout', component: OAuth2LogoutComponent },
  { path: '2FA-authentication', component: TwoFALoginAuthenticationComponent },
  { path: '2FA-setup', component: TwoFASetupComponent },
  { path: 'app-authentication', component: AppAuthenticationComponent },
  { path: 'confirm-link-accounts/secret/:secret/tenant/:tenant/answer/:answer', component: LinkAccountInfoComponent },
  // Logging in via an Able+ place’s unique URL
  { path: 'login/specific-place/:organisationId', component: SpecificPlaceLoginComponent },
  // Invitation sign up & log in
  { path: 'invitation/sign-up/:invitationId/:token', component: InvitationSignUpComponent },
  { path: 'invitation/oauth/connect/facebook', component: FacebookCallbackComponent },
  { path: 'invitation/oauth/connect/google', component: GoogleCallbackComponent },
  { path: 'invitation/oauth/connect/linkedin', component: LinkedinCallbackComponent },
  { path: 'invitation/oauth/connect/twitter', component: TwitterCallbackComponent },
  { path: 'login/oauth/connect/facebook', component: FacebookLoginCallbackComponent },
  { path: 'login/oauth/connect/google', component: GoogleLoginCallbackComponent },
  { path: 'login/oauth/connect/linkedin', component: LinkedInLoginCallbackComponent },
  { path: 'login/oauth/connect/twitter', component: TwitterLoginCallbackComponent },
  // Authentication email sign up & login
  { path: 'authentication-email/oauth/connect/facebook', component: AuthenticationFacebookCallbackComponent },
  { path: 'authentication-email/oauth/connect/google', component: AuthenticationGoogleCallbackComponent },
  { path: 'authentication-email/oauth/connect/linkedin', component: AuthenticationLinkedinCallbackComponent },
  // User prompt submit email
  { path: 'user-prompt/workflow-run/:workflowRunId/element/:workflowElementId/request/:requestId', component: UserPromptSubmitComponent },
   {
    path: "broker/authenticate",
    component: BrokerAuthorizeComponent
   },
  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

export const routing = RouterModule.forRoot(appRoutes, { useHash: false });
